export default {"src":"https://fishbrain.com/_next/static/media/alabama.4de676d6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};